export default __webpack_public_path__ + "images/8d7c90423d6887ef94945962d2994c36-plane-crash.png";